import { styled, InputBase, FormControl as FormControlMui } from '@mui/material';

export const BootstrapInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(3),
  },
  borderRadius: 100,
  '& .MuiInputBase-input': {
    width: 80,
    position: 'relative',
    backgroundColor: 'none',
    border: 'none',
    borderRadius: 100,
    padding: '0 12px 0 6px',
    color: '#65657B',
    fontSize: 14,
    fontWeight: 500,
    '&:focus': {
      borderRadius: '0 100px 100px 0',
    },
  },
}));

export const FormControl = styled(FormControlMui)({
  display: 'grid',
  gridTemplateColumns: 'auto auto',
  alignItems: 'center',
  justifyItems: 'start',
  justifyContent: 'start',
  gap: 6,
  margin: 0,
  border: '1px solid #E7E7EC',
  borderRadius: 100,
  paddingLeft: 12,
  height: 32,
});

export const FieldTitle = styled('span')({
  color: '#9393A3',
  fontWeight: 500,
  paddingTop: 2,
  paddingBottom: 1,
});
